import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import BannerCourseMappingValidationSchema from "../Validations/BannerValidation";

function BannerCourseMapping({
  open,
  onClose,
  bannerMap,
  popupmap,
  onSuccess,
}) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [selectedUniversityIds, setSelectedUniversityIds] = useState([]);
  console.log(popupmap);

  // Fetch universities once
  useEffect(() => {
    api
      .get("/getAllUniversities")
      .then((res) => setUniversities(res.data.data))
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching universities";
        setError(message);
        console.error("Universities fetch error:", err);
      });
  }, []);

  // Fetch courses, filtered by the selected universities via a param filter
  useEffect(() => {
    const params = {};
    if (selectedUniversityIds.length > 0) {
      params.universityIds = selectedUniversityIds;
    }

    api
      .get("/getCourses", {
        params: { ...params, active: true },
        // Send repeated "universityIds=1&universityIds=2" (Spring @RequestParam
        // List<Long> convention) instead of axios' default "universityIds[]=1"
        paramsSerializer: (p) => {
          const searchParams = new URLSearchParams();
          Object.keys(p).forEach((key) => {
            if (Array.isArray(p[key])) {
              p[key].forEach((value) => searchParams.append(key, value));
            } else {
              searchParams.append(key, p[key]);
            }
          });
          return searchParams.toString();
        },
      })
      .then((res) => setCourses(res.data.data))
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching courses";
        setError(message);
        console.error("Courses fetch error:", err);
      });
  }, [selectedUniversityIds]);
  const data = popupmap || bannerMap;
  const isPopup = !!popupmap;

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      [isPopup ? "popupId" : "bannerId"]: data?.id || "",

      active: data?.active !== undefined ? String(data.active) : "true",

      //   courseIds: data?.courseIds
      //     ? Array.isArray(data.courseIds)
      //       ? data.courseIds
      //       : [data.courseIds]
      //     : [],
      courseIds: data?.courses ? data.courses.map((c) => c.id) : [],
    },

    validationSchema:
      BannerCourseMappingValidationSchema.BannerCourseMappingValidationSchema(
        isPopup,
      ),
    enableReinitialize: true,

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        setSubmitting(true);
        let response;
        // If it's Edit data it will call Update api
        if (bannerMap?.id) {
          response = await api.post(`/api/v1/courseBannerMapping`, values);
          console.log(values);
        } else if (popupmap?.id) {
          response = await api.post(`/api/v1/coursePopupMapping`, values);
          console.log(values);
        }
        // Show success toast
        toast.success(
          `${popupmap ? "Popup" : "Banner"} Course Mapped successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          },
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
        // setTimeout(() => window.location.reload(), 2000);
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  //   change the label and field name based on whether it's banner or popup mapping
  const isPopups = !!popupmap;
  const fieldName = isPopups ? "popupId" : "bannerId";
  const label = isPopups ? "Popup ID" : "Banner ID";

  return (
    <>
      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {popupmap && Object.keys(popupmap).length > 0
              ? "Popup Course Mapping"
              : "Banner Course Mapping"}
          </Typography>

          <Box sx={FORM_STYLES.container}>
            <TextField
              label={label}
              name={fieldName}
              value={formik.values[fieldName]}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched[fieldName] && Boolean(formik.errors[fieldName])
              }
              helperText={formik.touched[fieldName] && formik.errors[fieldName]}
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl fullWidth>
              <InputLabel>University</InputLabel>
              <Select
                multiple
                label="University"
                value={selectedUniversityIds}
                onChange={(e) => {
                  setSelectedUniversityIds(e.target.value);
                  formik.setFieldValue("courseIds", []);
                }}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((id) => {
                      const university = universities.find((u) => u.id === id);
                      return (
                        <Chip
                          key={id}
                          label={university?.name || id}
                          size="small"
                          onDelete={() => {
                            setSelectedUniversityIds((prev) =>
                              prev.filter((uId) => uId !== id),
                            );
                            formik.setFieldValue("courseIds", []);
                          }}
                          onMouseDown={(event) => {
                            event.stopPropagation();
                          }}
                        />
                      );
                    })}
                  </Box>
                )}
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
              >
                {universities.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              sx={{ mt: 2 }}
              error={
                formik.touched.courseIds && Boolean(formik.errors.courseIds)
              }
            >
              <InputLabel>Courses</InputLabel>
              <Select
                multiple
                value={formik.values.courseIds}
                onChange={(e) =>
                  formik.setFieldValue("courseIds", e.target.value)
                }
                onBlur={() => formik.setFieldTouched("courseIds", true)}
                input={<OutlinedInput label="Courses" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((id) => {
                      const course = courses.find((c) => c.id === id);
                      return (
                        <Chip
                          key={id}
                          label={course?.courseName || id}
                          size="small"
                        />
                      );
                    })}
                  </Box>
                )}
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
              >
                {courses.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.courseName}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.courseIds && formik.errors.courseIds && (
                <FormHelperText>{formik.errors.courseIds}</FormHelperText>
              )}
            </FormControl>

            {/* <TextField
              label="Display Order"
              name="displayOrder"
              value={formik.values.displayOrder}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.displayOrder &&
                Boolean(formik.errors.displayOrder)
              }
              helperText={
                formik.touched.displayOrder && formik.errors.displayOrder
              }
              {...TEXT_FIELD_STYLES.standard}
            /> */}
            {/* <FormControl
              fullWidth
              error={
                formik.touched.universities &&
                Boolean(formik.errors.universities)
              }
              sx={{ mt: 2 }}
            >
              <InputLabel id="universities-label">Universities</InputLabel>
              <Select
                labelId="universities-label"
                id="universities"
                name="universities"
                value={formik.values.universities || []}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Universities"
              >
                {universities.map((university) => (
                  <MenuItem key={university.id} value={university.id}>
                    {university.id} - {university.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.universities && formik.errors.universities && (
                <FormHelperText>{formik.errors.universities}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={formik.touched.courses && Boolean(formik.errors.courses)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="courses-label">Courses</InputLabel>
              <Select
                labelId="courses-label"
                id="courses"
                name="courses"
                value={formik.values.courses || []}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Courses"
              >
                {courses.map((course) => (
                  <MenuItem key={course.id} value={course.id}>
                    {course.id} - {course.courseName}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.courses && formik.errors.courses && (
                <FormHelperText>{formik.errors.courses}</FormHelperText>
              )}
            </FormControl> */}
            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>

            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                {...BUTTON_STYLES.primary}
              >
                {formik.isSubmitting ? "Processing..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default BannerCourseMapping;
